import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "api-tester-panel" }
const _hoisted_2 = { style: {"margin-bottom":"2rem","padding-bottom":"1rem","border-bottom":"1px solid #333"} }
const _hoisted_3 = { class: "form-label" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = { class: "api-endpoints" }
const _hoisted_7 = { class: "card-header d-flex align-items-center" }
const _hoisted_8 = { class: "badge badge-success me-2" }
const _hoisted_9 = { class: "fs-5 me-2" }
const _hoisted_10 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_11 = { class: "card-body" }
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = {
  key: 0,
  class: "row g-3 mb-3"
}
const _hoisted_14 = { class: "form-label text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["onUpdate:modelValue", "type", "name", "required", "placeholder"]
const _hoisted_19 = { class: "form-actions d-flex align-items-center" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "mt-3 p-2 rounded bg-dark text-light",
  style: {"max-height":"200px","overflow-y":"auto","font-size":"0.85rem"}
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, _toDisplayString($setup.label("tokenLabel", "API Token (JWT)")), 1 /* TEXT */),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.token) = $event)),
        type: "password",
        class: "form-control",
        placeholder: $setup.label('tokenPlaceholder', 'Paste your JWT token here to use in all tests below'),
        onInput: $setup.saveToken
      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_4), [
        [_vModelText, $setup.token]
      ]),
      _createElementVNode("small", _hoisted_5, _toDisplayString($setup.label("tokenHint", "Token is saved in your browser's local storage automatically.")), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.endpoints, (endpoint, endpointIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${endpoint.method}-${endpoint.path}`,
          class: "endpoint-card card mb-3"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(endpoint.method), 1 /* TEXT */),
            _createElementVNode("code", _hoisted_9, _toDisplayString(endpoint.path), 1 /* TEXT */),
            (endpoint.description)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, "- " + _toDisplayString(endpoint.description), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("form", {
              onSubmit: _withModifiers($event => ($setup.submitEndpoint(endpointIndex, endpoint)), ["prevent"])
            }, [
              (endpoint.fields?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(endpoint.fields, (field) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: field.name,
                        class: _normalizeClass(field.colClass || 'col-md-2')
                      }, [
                        _createElementVNode("label", _hoisted_14, [
                          _createTextVNode(_toDisplayString(field.label) + " ", 1 /* TEXT */),
                          (field.required)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, "*"))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (field.type === 'select')
                          ? _withDirectives((_openBlock(), _createElementBlock("select", {
                              key: 0,
                              "onUpdate:modelValue": $event => (($setup.formValues[$setup.fieldKey(endpointIndex, field.name)]) = $event),
                              class: "form-control form-control-sm"
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(field.options, (option) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: option.value,
                                  value: option.value
                                }, _toDisplayString(option.label), 9 /* TEXT, PROPS */, _hoisted_17))
                              }), 128 /* KEYED_FRAGMENT */))
                            ], 8 /* PROPS */, _hoisted_16)), [
                              [_vModelSelect, $setup.formValues[$setup.fieldKey(endpointIndex, field.name)]]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 1,
                              "onUpdate:modelValue": $event => (($setup.formValues[$setup.fieldKey(endpointIndex, field.name)]) = $event),
                              type: field.type || 'text',
                              name: field.name,
                              required: field.required,
                              class: "form-control form-control-sm",
                              placeholder: field.placeholder
                            }, null, 8 /* PROPS */, _hoisted_18)), [
                              [_vModelDynamic, $setup.formValues[$setup.fieldKey(endpointIndex, field.name)]]
                            ])
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-sm btn-primary me-3",
                  disabled: $setup.requests[endpointIndex]?.isLoading
                }, _toDisplayString($setup.label("testButton", "Test Endpoint")), 9 /* TEXT, PROPS */, _hoisted_20),
                ($setup.requests[endpointIndex]?.statusText)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass($setup.requests[endpointIndex]?.statusClass)
                    }, _toDisplayString($setup.requests[endpointIndex]?.statusText), 3 /* TEXT, CLASS */))
                  : _createCommentVNode("v-if", true)
              ]),
              ($setup.requests[endpointIndex]?.showOutput)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_21, _toDisplayString($setup.requests[endpointIndex]?.output), 1 /* TEXT */))
                : _createCommentVNode("v-if", true)
            ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12)
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}